/**
 * @generated SignedSource<<4df81efbdb4b64085881feb50d1c3add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NumberOfPeopleQuery$variables = {
  clientId: string;
  maxUserCount: number;
};
export type NumberOfPeopleQuery$data = {
  readonly oauthClients: {
    readonly client: {
      readonly consentedUserCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type NumberOfPeopleQuery = {
  response: NumberOfPeopleQuery$data;
  variables: NumberOfPeopleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "maxUserCount"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OAuthClientsQuery",
    "kind": "LinkedField",
    "name": "oauthClients",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "clientId"
          }
        ],
        "concreteType": "OAuthClientsClient",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "max",
                "variableName": "maxUserCount"
              }
            ],
            "kind": "ScalarField",
            "name": "consentedUserCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NumberOfPeopleQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NumberOfPeopleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6387ccc8becc20f998df7ebc7ce30e14",
    "id": null,
    "metadata": {},
    "name": "NumberOfPeopleQuery",
    "operationKind": "query",
    "text": "query NumberOfPeopleQuery(\n  $clientId: ID!\n  $maxUserCount: Int!\n) {\n  oauthClients {\n    client(id: $clientId) {\n      consentedUserCount(max: $maxUserCount)\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0205a465ed8095c89ce547ce4caca8dc";

export default node;
